/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  ensureContrast,
  AA_TEXT_PRIMARY_ON_LIGHT,
  AA_SURFACE,
} from '~/modules/Helper/contrast.helper';

export const MIN_ZOOM_FONTE = -5;
export const MAX_ZOOM_FONTE = 5;

const INITIAL_STATE = {
  titulo: '',
  corFonteTituloPortal: '#000',
  // Texto de cards/gráficos sobre fundo claro — default AA-safe (antes #fff falhava)
  corFonte: AA_TEXT_PRIMARY_ON_LIGHT,
  corFundoGrid: AA_SURFACE,
  corFonteGrid: AA_TEXT_PRIMARY_ON_LIGHT,
  corFonteRodape: '#000',
  corFundoRodape: '#f0f2f5',
  corTema: '',

  brasao: '',
  brasaoPB: '',
  banner: '',
  bgImageHome: '',
  bgImageTelas: '',

  RazaoSocial: '',
  ChaveCliente: '',
  endereco: '',
  bairro: '',
  cidade: '',
  cep: '',
  telefone: '',
  atendimento: '',

  EmailSocials: '',
  FacebookSocials: '',
  InstagramSocials: '',
  LinkedInSocials: '',
  TwitterSocials: '',
  WhatsAppSocials: '',
  YoutubeSocials: '',

  zoomFonte: 0,
  highContrast: false,
  /** true após config/cliente + MenuPortal — libera VLibras etc. */
  portalBootReady: false,

  graficHighContrastStyle: {
    fill: '#ffff00',
    shadowColor: '#000000',
    stroke: '#000000',
    shadowBlur: 2,
    lineWidth: 1,
    strokeOpacity: 1,
  },
  graficDefaultStyle: {
    fill: AA_TEXT_PRIMARY_ON_LIGHT,
    shadowColor: AA_TEXT_PRIMARY_ON_LIGHT,
    stroke: AA_TEXT_PRIMARY_ON_LIGHT,
    shadowBlur: 0,
    lineWidth: 0.3,
    strokeOpacity: 0,
  },
};

function configurationReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case '@configuration/TOGGLE_HIGHCONTRAST':
      return produce(state, draft => {
        draft.highContrast = !state.highContrast;
      });

    case '@configuration/SET_CONFIGURATION':
      return produce(state, draft => {
        draft.titulo = action.payload.Titulo;
        // WCAG Onda 3 — normaliza cores de texto para contraste AA nos fundos típicos
        draft.corFonteTituloPortal = ensureContrast(
          action.payload.CorFonteTituloPortal,
          AA_SURFACE
        );
        draft.corFonteTituloTelas = ensureContrast(
          action.payload.CorFonteTituloTelas,
          AA_SURFACE
        );
        draft.corFonteRodape = ensureContrast(
          action.payload.CorFonteRodape,
          action.payload.CorFundoRodape || '#f0f2f5'
        );
        draft.corFundoRodape = action.payload.CorFundoRodape || '#f0f2f5';
        draft.corTema = ensureContrast(action.payload.CorTema, AA_SURFACE);
        draft.corFonte = ensureContrast(action.payload.CorFonte, AA_SURFACE);
        draft.corFundoGrid = action.payload.CorFundoGrid || AA_SURFACE;
        draft.corFundoTituloGrid =
          action.payload.CorFundoTituloGrid || AA_SURFACE;
        draft.corTituloGrid = ensureContrast(
          action.payload.CorTituloGrid,
          draft.corFundoTituloGrid
        );
        draft.corFonteGrid = ensureContrast(
          action.payload.CorFonteGrid || action.payload.CorFonte,
          draft.corFundoGrid
        );

        draft.brasao = action.payload.BrasaoUrl;
        draft.brasaoPB = action.payload.BrasaoPretoBrancoUrl;
        draft.banner = action.payload.BannerUrl;
        draft.bgImageHome = action.payload.ImagemFundoHomeUrl;
        draft.bgImageTelas = action.payload.ImagemFundoTelasUrl;

        draft.RazaoSocial = action.payload.RazaoSocial;
        draft.ChaveCliente = action.payload.ChaveCliente || '';
        draft.endereco = action.payload.Endereco;
        draft.bairro = action.payload.Bairro;
        draft.cidade = action.payload.Cidade;
        draft.cep = action.payload.CEP;
        draft.telefone = action.payload.Telefone;
        draft.atendimento = action.payload.Atendimento;
        draft.graficHighContrastStyle = INITIAL_STATE.graficHighContrastStyle;
        draft.graficDefaultStyle = INITIAL_STATE.graficDefaultStyle;
        draft.EmailSocials = action.payload.EmailSocials;
        draft.FacebookSocials = action.payload.FacebookSocials;
        draft.InstagramSocials = action.payload.InstagramSocials;
        draft.LinkedInSocials = action.payload.LinkedInSocials;
        draft.TwitterSocials = action.payload.TwitterSocials;
        draft.WhatsAppSocials = action.payload.WhatsAppSocials;
        draft.YoutubeSocials = action.payload.YoutubeSocials;
      });

    case '@configuration/SET_PORTAL_BOOT_READY':
      return produce(state, draft => {
        draft.portalBootReady = true;
      });

    case '@configuration/DECREASE_FONTSIZE_PAGE':
      return produce(state, draft => {
        if (draft.zoomFonte > MIN_ZOOM_FONTE) {
          draft.zoomFonte -= 1;
        }
      });

    case '@configuration/INCREASE_FONTSIZE_PAGE':
      return produce(state, draft => {
        if (draft.zoomFonte < MAX_ZOOM_FONTE) {
          draft.zoomFonte += 1;
        }
      });

    case '@configuration/RESET_FONTSIZE_PAGE':
      return produce(state, draft => {
        draft.zoomFonte = INITIAL_STATE.zoomFonte;
      });

    default:
      return state;
  }
}

export default configurationReducer;
